import React, { useState, useEffect } from "react";
import LogLocalTable from "./components/LogLocalTable";
 import Create from "./modals/CreateLocal";
import axios from "axios";
import Delete from "./modals/RemoveLocal";

export default function LogLocal(props) {
    const {
        chooseDevicePlaceId,
        setChooseDevicePlaceId,
        isLoading,
        isError,
        logLocalRows,
        setSortField,
        setOrderByTable,
        sortField,
        orderBy,
        count,
        skip,take,
        updateSkip,
        updateTake,
        onLogLocalRows
    } = props;

    const [logId, setLogId] = useState(undefined);
    const [showCreate, setShowCreate] = useState(false);
    const [showRemove, setShowRemove] = useState(false);


   
    const [structureId, setStructureId] = useState();


    useEffect(() => {
      axios
        .get(`${process.env.REACT_APP_API_URL}structure/select`)
        .then((res) => {
          const structureId = res.data.map(({ id, name }) => ({
            value: id,
            label: name,
          }));
          setStructureId(structureId);
        });
    }, []);





    return (
        <div className="row bg-white rounded SHADOW">
            <div className="col-12 d-flex  mt-3 ">
                <LogLocalTable
                    logRows={logLocalRows}
                    chooseDevicePlaceId={chooseDevicePlaceId}
                    setChooseDevicePlaceId={setChooseDevicePlaceId}
                    setSortField={setSortField}
                    setOrderByTable={setOrderByTable}
                    sortField={sortField}
                    orderBy={orderBy}
                    updateSkip={updateSkip}
                    updateTake={updateTake}
                    count={count}
                    isLoading={isLoading}
                    isError={isError}
                    setLogId={setLogId}
                    logId={logId}
                    setShowCreate={setShowCreate}
                    setShowRemove={setShowRemove}

                />
            </div>
  


    {showCreate && (
        <Create 
        structureId={structureId}
        logId={logId}
         id={chooseDevicePlaceId}
         onLogLocalRows={onLogLocalRows}
        show={showCreate} 
        onHide={setShowCreate} 
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
          />
      )}  
       {showRemove && (
        <Delete
          id={chooseDevicePlaceId}
          show={showRemove}
          onHide={setShowRemove}
          onLogRows={onLogLocalRows}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          logId={logId}

        />
      )}
        </div>

    );
}
